"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getUcnId = function getUcnId(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? window.location.href : _ref$url;

  try {
    var urlObject = new URL(url);
    var ucnId = urlObject.searchParams.get("ucnId");
    urlObject.searchParams["delete"]("ucnId");
    return {
      originUrl: urlObject.toString(),
      ucnId: ucnId,
      isValidUrl: true
    };
  } catch (error) {
    return {
      isValidUrl: false
    };
  }
};

var _default = getUcnId;
exports["default"] = _default;